import { createContext, useContext } from 'react';
import { UploadEditorReadinessState } from '@/hooks/useUploadEditorReadiness';

export interface UploadEditorReadinessContextValue extends UploadEditorReadinessState {
  setEditorLoaded: (loaded: boolean) => void;
}

const defaultState: UploadEditorReadinessContextValue = {
  clipsReady: true,
  facialRecTerminal: true,
  screenshareTerminal: true,
  layoutsReady: true,
  setEditorLoaded: () => undefined
};

export const UploadEditorReadinessContext = createContext<UploadEditorReadinessContextValue>(defaultState);

export function useUploadEditorReadinessContext(): UploadEditorReadinessContextValue {
  return useContext(UploadEditorReadinessContext);
}
